import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'readableDate', pure: false })
export class ReadableDatePipe implements PipeTransform {
  constructor() {
  }

  transform(content) {
    const date = new Date(content);
    return date.toLocaleDateString();
  }
}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/utilities/pipes/readable-date.pipe.ts